/* Stylesheet */

.item_options {
  .item_option {
    width: 52px;

    .icon {
      height: 18px;
      width: 18px;
    }
  }

  .edit {
    border-radius: 4px 0px 0px 4px;
    background: var(--ion-color-primary);
  }

  .delete {
    background: var(--ion-color-error);
  }
}
